/** @jsxImportSource @emotion/react */
import { useMemo } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import LabMapsPage from './LabMapsPage';

const VALID_TABS = ['population', 'housing', 'lifestyle'];

const LabMapsRoute = () => {
    const { tab } = useParams();
    const navigate = useNavigate();

    const currentTab = useMemo(() => {
        if (!tab) return 'population';
        return VALID_TABS.includes(tab) ? tab : 'population';
    }, [tab]);

    const handleTabChange = (nextTab) => {
        if (!VALID_TABS.includes(nextTab) || nextTab === currentTab) return;
        navigate(`/lab/lab_2/maps/${nextTab}`, { replace: false });
    };

    if (tab && !VALID_TABS.includes(tab)) {
        return <Navigate to="/lab/lab_2/maps/population" replace />;
    }

    return <LabMapsPage activeTab={currentTab} onTabChange={handleTabChange} />;
};

export default LabMapsRoute;
